import styled from "styled-components";

export const FormSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
